/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pearl_Loud_Ant_CallInputs */

const en_pearl_loud_ant_call = /** @type {(inputs: Pearl_Loud_Ant_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure AI-powered comment analysis`)
};

const de_pearl_loud_ant_call = /** @type {(inputs: Pearl_Loud_Ant_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-gestützte Kommentaranalyse konfigurieren`)
};

/**
* | output |
* | --- |
* | "Configure AI-powered comment analysis" |
*
* @param {Pearl_Loud_Ant_CallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pearl_loud_ant_call = /** @type {((inputs?: Pearl_Loud_Ant_CallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pearl_Loud_Ant_CallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pearl_loud_ant_call(inputs)
	return de_pearl_loud_ant_call(inputs)
});